/* eslint-disable @typescript-eslint/no-empty-function */
/**
 * Checks that native and js versions of reanimated match.
 * Stubbed for web, where this check is unnecessary.
 */
export function checkVersion(): void {}
